export default __webpack_public_path__ + "static/media/sampleHtml.b6a6a43e.svg";